import React from "react";
import { useGetUniversQuery } from "../../store/api/app";
import { Box, styled } from "@mui/material";

const BoxUnivers = styled(Box)(({ theme }) => {
	return {
		pointer: "cursor",
		opacity: 0,
		transition: theme.transitions.create(["transform", "opacity", "visibility"]),
		visibility: "hidden",
		"&.isActive": {
			transform: "translateY(0)",
			opacity: 1,
			visibility: "visible",
		},
	};
});

const BoxSubUnivers = styled(Box)(({ theme }) => {
	return {
		display: "flex",
		borderRadius: 15,
		margin: "auto",
		pointer: "cursor",
		alignItems: "center",
		justifyContent: "center",
	};
});

const UniversImage = styled("img")(({ theme }) => {
	return {
		width: "100%",
		objectFit: "contain",
	};
});

const UniversLink = styled("a")(({ theme }) => {
	return {
		width: 150,
		height: 100,
		display: "flex",
		borderRadius: 6,
		marginTop: 12,
		marginBottom: 12,
		cursor: "pointer",
	};
});

const UniversesList = ({ isOpen = true, inSubMenu = false, isMobile = false, ...props }) => {
	const { data: univers } = useGetUniversQuery();

	const absoluteStyle = !isMobile
		? {
				position: "absolute",
				top: 0,
				right: 0,
				transform: "translateY(-15%)",
				paddingTop: 10,
			}
		: { position: "absolute", top: 0, left: 0, transform: "translateY(-15%)", paddingTop: 10 };

	return (
		<BoxUnivers className={isOpen ? "isActive" : ""} sx={inSubMenu ? absoluteStyle : {}}>
			<BoxSubUnivers
				sx={{
					backgroundColor: inSubMenu ? "rgba(255,255,255,0.5)" : "none",
				}}
			>
				{univers?.map((item, index) => (
					<UniversLink
						href={item.lien}
						key={item.titre}
						sx={{
							background: `#${item.background}`,
							marginLeft: index === 0 ? "12px" : "6px",
							marginRight: index === 1 ? "12px" : "6px",
						}}
					>
						<UniversImage src={item.logo} alt={item.titre} />
					</UniversLink>
				))}
			</BoxSubUnivers>
		</BoxUnivers>
	);
};

export default UniversesList;
